"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GET_QUANTUM_VARIANT_COUNTS = void 0;

var _client = require("@apollo/client");

const GET_QUANTUM_VARIANT_COUNTS = _client.gql`
  query getQuantumVariantCounts(
    $experimentId: String!
    $asOfDenverDate: String!
    $applicationCoords: [String!]!
    $subdimensions: [String]
  ) {
    counts(
      experimentId: $experimentId
      denverDate: $asOfDenverDate
      applicationCoords: $applicationCoords
      subdimensions: $subdimensions
    ) {
      denverDate
      experimentId
      variantId
      applicationCoords
      subdimensionName
      subdimensionValue
      cumulativeUniqueAccounts
      cumulativeUniqueDevices
    }
  }
`;
exports.GET_QUANTUM_VARIANT_COUNTS = GET_QUANTUM_VARIANT_COUNTS;